export default __webpack_public_path__ + "static/media/car-under-3.5f0f444d.png";